import React, { lazy, Suspense } from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { EditorRoute } from '../Editor.route';
import { GoogleLoginRoute } from '../GoogleLogin.route';
import { NotFoundRoute } from '../NotFound.route';
import { UploadFamilyFriendsRoute } from '../UploadFamilyFriends.route';
import { UploadSmartphoneRoute } from '../UploadSmartphone.route';
import { LoginRoute } from '../Login.route';
import { ROUTE_NAMES, ROUTE_PATHS } from './routes.constants';
import { EDITOR_BASE_URL } from '../../app/settings';
import { UploadV3Route } from '../UploadV3.route';
import { EditRoute } from '../Edit.route';
import { TRouteComponent } from './routes.types';
import isProduction from 'src/_shared/utils/isProduction';
import { EditorNewRoute } from '../EditorNew.route';

const RootStack = createNativeStackNavigator();

const storybookRoute: Partial<Record<ROUTE_NAMES, { path: ROUTE_PATHS; component: TRouteComponent }>> = !isProduction()
  ? (() => {
      const LazyStorybookRoute = lazy(() =>
        import('../Storybook.route').then(m => ({ default: m.StorybookRoute }))
      );
      const StorybookRouteWrapper: TRouteComponent = props => (
        <Suspense fallback={null}>
          <LazyStorybookRoute {...props} />
        </Suspense>
      );
      return { [ROUTE_NAMES.Storybook]: { path: ROUTE_PATHS.STORYBOOK, component: StorybookRouteWrapper } };
    })()
  : {};

export const ROUTES_MAP: Partial<Record<ROUTE_NAMES, { path: ROUTE_PATHS; component: TRouteComponent }>> = {
  [ROUTE_NAMES.GoogleLogin]: { path: ROUTE_PATHS.GOOGLE_LOGIN, component: GoogleLoginRoute },
  [ROUTE_NAMES.Editor]: { path: ROUTE_PATHS.EDITOR, component: EditorRoute },
  [ROUTE_NAMES.UploadSmartphone]: { path: ROUTE_PATHS.UPLOAD_SMARTPHONE, component: UploadSmartphoneRoute },
  [ROUTE_NAMES.UploadFamilyFriends]: { path: ROUTE_PATHS.UPLOAD_FAMILY_FRIENDS, component: UploadFamilyFriendsRoute },
  [ROUTE_NAMES.EditorNew]: {
    path: ROUTE_PATHS.EDITOR_NEW,
    component: EditorNewRoute,
  },
  [ROUTE_NAMES.Upload]: {
    path: ROUTE_PATHS.UPLOAD,
    component: UploadV3Route,
  },
  [ROUTE_NAMES.Edit]: {
    path: ROUTE_PATHS.EDIT,
    component: EditRoute,
  },
  [ROUTE_NAMES.Login]: { path: ROUTE_PATHS.LOGIN, component: LoginRoute },
  [ROUTE_NAMES.NotFound]: { path: ROUTE_PATHS.NOT_FOUND, component: NotFoundRoute },
  ...storybookRoute,
};

const linking = {
  prefixes: [EDITOR_BASE_URL],
  enabled: true,
  config: {
    screens: Object.entries(ROUTES_MAP).reduce(
      (acc, [key, value]) => {
        return {
          ...acc,
          [key]: value.path,
        };
      },
      {} as Partial<Record<ROUTE_NAMES, ROUTE_PATHS>>,
    ),
  },
};

export function AppNavigator() {
  return (
    <NavigationContainer linking={linking}>
      <RootStack.Navigator screenOptions={{ headerShown: false, title: 'Editor PhotoSì' }}>
        {Object.entries(ROUTES_MAP).map(([key, value]) => (
          <RootStack.Screen key={key} name={key} component={value.component} />
        ))}
      </RootStack.Navigator>
    </NavigationContainer>
  );
}
